/**
 * MageGuide - Progressive Web App for Magento
 *
 * Copyright © MageGuide, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 */

import { Field } from "SourceUtil/Query";
import ProductListQuery from "Query/ProductList.query";

/** @namespace Query/AutoRelatedProducts */
export class AutoRelatedProductsQuery {
  getQuery(productId, position) {
    if (!productId) {
      throw new Error("Missing argument `options`");
    }

    const mostViewQuery = new Field("amMostviewedGroups")
    if(position == 'cart') {
        mostViewQuery.addArgument('_id', 'String', productId)
    } else {
      mostViewQuery.addArgument('id', 'Int!', productId)
    }
    mostViewQuery.addArgument('position', 'String', position)
    mostViewQuery.addField(this._getItemsField());

      return mostViewQuery;
  }

  _getProducts() {
    ProductListQuery.options.isForLinkedProducts = true;
    // ProductListQuery.options.noAttributes = true;
    ProductListQuery.options.noVariantAttributes = true;
    ProductListQuery.options.isPlp = true;
    ProductListQuery.options.isCart = true;
    ProductListQuery.options.isSlider = true;

    const productQuery = new Field('items')
        .addFieldList(ProductListQuery._getProductInterfaceFieldsOptz(false, true));

    ProductListQuery.options.isSlider = false;
    ProductListQuery.options.isCart = false;
    ProductListQuery.options.isPlp = false;
    ProductListQuery.options.isForLinkedProducts = false;
    // ProductListQuery.options.noAttributes = false;
    ProductListQuery.options.noVariantAttributes = false;   
    
    return productQuery;
  }

  _getItemFields() {
    return [
      "block_title",
      "position",
      "add_to_cart",
      "block_layout",
      this._getProducts(),
    ];
  }

  _getItemsField() {
    return new Field("items").addFieldList(this._getItemFields());
  }
}

export default new AutoRelatedProductsQuery();
